/* eslint-disable */
import { createStore } from 'vuex'
import axios from 'axios'
import { fetchAuthSession, getCurrentUser, signOut } from 'aws-amplify/auth';

// Redeclaring the API URL so we can use it in this file without having to eslint for eternity. It is originally declared in the index.html file and passed in on build.
const LOCAL_API_BASE_URI = process.env.VUE_APP_APIURL + '/V2/';

const getDefaultOpmState = () => {
    return {
        chrome: {
            primaryNav: [],
            roles: [],
            home: '',
        },
        error: false,
        errors: [],
        calculating: false,
        isPageDataLoading: false,
        breadcrumbs: [],
    };
};
const storeOwnerProjectManager = createStore({
    state() {
        return getDefaultOpmState();
    },
    getters: {
        getBreadcrumbs: (state) => {
            return state.breadcrumbs || [];
        },
    },
    actions: {
        async getAuthJwt(){
            const authSession = await fetchAuthSession();
            return authSession.tokens.idToken.toString();
        },
        async generateAPIHeaders(context){
            const jwt = await context.dispatch('getAuthJwt')
            return {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': jwt
                }
            };
        },
        async getUserChrome(context) {
            const fetchURL = `${LOCAL_API_BASE_URI}userChrome`;
            const headers = await storeOwnerProjectManager.dispatch('generateAPIHeaders');
            await axios.get(fetchURL, headers)
            .then(async function (response) {
                await context.commit('SET_USER_CHROME', response.data.data);
            }).catch(error => {
                context.commit('SET_ERROR', error);
            });
        },
        async deleteState(context) {
            context.commit("DELETE_STATE");
        },
        async clearErrors(context) {
            context.commit("CLEAR_ERRORS");
        },
        async setIsPageDataLoading(context, isLoading) {
            context.state.isPageDataLoading = isLoading;
        },
        async setBreadcrumbs(context, breadcrumbs) {
            context.state.breadcrumbs = breadcrumbs;
        },
        async setError(context, errorText) {
            context.dispatch('clearErrors');
            context.state.errors.push(errorText);
        },


        async addPdfToQueue(context, request){
            const headers = await storeOwnerProjectManager.dispatch('generateAPIHeaders');
            const fetchURL = `${LOCAL_API_BASE_URI}pdf/project-status-report`;
            return await axios.post(fetchURL, request, headers)
            .then(async function (response) {
                return response.data;
            })
            .catch(error => {
                context.commit('SET_ERROR', error);
            });
        },
        async addJobOrderReportPdfToQueue(context, request){
            const headers = await storeOwnerProjectManager.dispatch('generateAPIHeaders');
            const fetchURL = `${LOCAL_API_BASE_URI}pdf/job-order-report`;
            return await axios.post(fetchURL, request, headers)
            .then(async function (response) {
                return response.data;
            })
            .catch(error => {
                context.commit('SET_ERROR', error);
            });
        },
        
        async checkPdfStatus(context, requestId){
            const headers = await storeOwnerProjectManager.dispatch('generateAPIHeaders');
            const fetchURL = `${LOCAL_API_BASE_URI}pdf/project-status-report/${requestId}`;
            return await axios.get(fetchURL, headers)
            .then(async function (response) {
                return response.data;
            })
            .catch(error => {
                context.commit('SET_ERROR', error);
            });
        },



        

        async getProjectStatusReport(context, entityId){
            const headers = await storeOwnerProjectManager.dispatch('generateAPIHeaders');
            const fetchURL = `${process.env.VUE_APP_APIURL}/reports/project-status/${entityId}`;
            return await axios.get(fetchURL, headers)
            .then(async function (response) {
                return response.data;
            })
            .catch(error => {
                context.commit('SET_ERROR', error);
            });
        },
        async getJobOrderReport(context, entityId){
            const headers = await storeOwnerProjectManager.dispatch('generateAPIHeaders');
            const fetchURL = `${process.env.VUE_APP_APIURL}/reports/job-order/${entityId}`;
            return await axios.get(fetchURL, headers)
            .then(async function (response) {
                return response.data;
            })
            .catch(error => {
                context.commit('SET_ERROR', error);
            });
        },

        async getPageData(context, request){
            let requestQuery = '';
            if(request.query){
                request.query.forEach((query, index) => {
                    const separator = index === 0 ? '?' : '&';
                    requestQuery += `${separator}${query.key}=${query.value}`;
                });
            };
            const headers = await storeOwnerProjectManager.dispatch('generateAPIHeaders');
            let fetchURL = `${LOCAL_API_BASE_URI}${request.entityType}/${request.entityId}${requestQuery}`;
            if(request?.fetchType){
                fetchURL = `${LOCAL_API_BASE_URI}${request.entityType}/${request.entityId}/${request.fetchType}${requestQuery}`;
            }
            if(request.isMainData){
                storeOwnerProjectManager.dispatch("setIsPageDataLoading", true);
            }
            return await axios.get(fetchURL, headers)
            .then(async function (response) {
                return response.data;
            })
            .catch(error => {
                context.commit('SET_ERROR', error);
            }).finally(() => {
                if(request.isMainData){
                    storeOwnerProjectManager.dispatch("setIsPageDataLoading", false);
                }
            });
        },
        
        async getEntityCreate(context, request){
            let requestQuery = '';
            if(request.query){
                request.query.forEach((query, index) => {
                    const separator = index === 0 ? '?' : '&';
                    requestQuery += `${separator}${query.key}=${query.value}`;
                });
            };
            const headers = await storeOwnerProjectManager.dispatch('generateAPIHeaders');
            let fetchURL = `${LOCAL_API_BASE_URI}create/${request.entityType}${requestQuery}`;
            if(request.parentId){
                fetchURL = `${LOCAL_API_BASE_URI}create/${request.entityType}/${request.parentId}${requestQuery}`;
            }
            if(request.isMainData){
                storeOwnerProjectManager.dispatch("setIsPageDataLoading", true);
            }
            return await axios.get(fetchURL, headers)
            .then(async function (response) {
                return response.data;
            })
            .catch(error => {
                context.commit('SET_ERROR', error);
            }).finally(() => {
                if(request.isMainData){
                    storeOwnerProjectManager.dispatch("setIsPageDataLoading", false);
                }
            });
        },
        
        async patchEntityData(context, request){
            const headers = await storeOwnerProjectManager.dispatch('generateAPIHeaders');
            const fetchURL = `${LOCAL_API_BASE_URI}${request.endpoint}`;
            return await axios.patch(fetchURL, request.payload, headers)
            .then(async function (response) {
                return response.data;
            })
            .catch(error => {
                context.commit('SET_ERROR', error);
            });
        },
        
        async putEntityData(context, request){
            const headers = await storeOwnerProjectManager.dispatch('generateAPIHeaders');
            const fetchURL = `${LOCAL_API_BASE_URI}${request.endpoint}`;
            return await axios.put(fetchURL, request.payload, headers)
            .then(async function (response) {
                return response.data;
            })
            .catch(error => {
                context.commit('SET_ERROR', error);
            });
        },
        
        async postEntityData(context, request){
            const headers = await storeOwnerProjectManager.dispatch('generateAPIHeaders');
            const fetchURL = `${LOCAL_API_BASE_URI}${request.endpoint}`;
            return await axios.post(fetchURL, request.payload, headers)
            .then(async function (response) {
                return response.data;
            })
            .catch(error => {
                context.commit('SET_ERROR', error);
            });
        },

        async getOptionsList(context, request){
            const headers = await storeOwnerProjectManager.dispatch('generateAPIHeaders');
            const fetchURL = `${LOCAL_API_BASE_URI}options-list/${request.fetchQuery}/${request.entityId}`;
            return await axios.get(fetchURL, headers)
            .then(async function (response) {
                return response.data;
            })
            .catch(error => {
                context.commit('SET_ERROR', error);
            });
        },
        
        async postCalculationWorkOrderDates(context, payload){
            const headers = await storeOwnerProjectManager.dispatch('generateAPIHeaders');
            const fetchURL = `${LOCAL_API_BASE_URI}calculations/work-order-dates`;
            return await axios.post(fetchURL, payload, headers)
            .then(async function (response) {
                return response.data;
            })
            .catch(error => {
                context.commit('SET_ERROR', error);
            });
        },

        async fetchDownload(context, fetchRequest) {
            const headers = await storeOwnerProjectManager.dispatch('generateAPIHeaders');
            const fetchURL = `${LOCAL_API_BASE_URI}download`;
            
            await axios.post(fetchURL, fetchRequest, headers)
            .then(async function (response) {
                window.open(response.data.data)
            })
            .catch(error => {
                context.commit('SET_ERROR', error);
            });
        },

        async deleteEntity(context, request){
            const headers = await storeOwnerProjectManager.dispatch('generateAPIHeaders');
            // The delete endpoint is at root API level, not under /V2/
            const rootApiBaseUri = process.env.VUE_APP_APIURL + '/';
            const fetchURL = `${rootApiBaseUri}${request.entityType}/${request.entityId}`;
            console.log("fetchURL:", fetchURL);
            return await axios.delete(fetchURL, headers)
            .then(async function (response) {
                return response.data;
            })
            .catch(error => {
                context.commit('SET_ERROR', error);
                return { success: false, error: error };
            });
        },
    },
    mutations: {
        SET_USER_CHROME(state, chromeObject) {
            state.chrome = {
                ...state.chrome,
                ...chromeObject
            };
        },
        DELETE_STATE() {
            storeOwnerProjectManager.replaceState(getDefaultOpmState());
        },
        SET_ERROR(state, error){
            if(error?.response?.data?.message){
                state.errors.push(error.response.data.message);
                return;
            }else{
                state.errors.push(`${error.message}: ${error.config.url}`);
            }
        },
        CLEAR_ERRORS(state){
            state.errors = [];
        }
    },
});

export default storeOwnerProjectManager;